import { FeedbackType } from '@src/globalTypes'
import { GetPaper_getPaper_feedbacks_feedbackContent } from '@src/queries/GetPaper'
import { createStandardAction } from 'typesafe-actions'

export const EXPERT_CHECK_CREATE_TICKET = 'expertCheck/CREATE_TICKET'
export const EXPERT_CHECK_CREATE_SUCCESS = 'expertCheck/CREATE_TICKET_SUCCESS'
export const EXPERT_CHECK_CREATE_FAILURE = 'expertCheck/CREATE_TICKET_FAILURE'
export const EXPERT_CHECK_SET_SUCCESS_REDIRECT_FALSE =
  'expertCheck/SET_SUCCESS_REDIRECT_FALSE'
export const EXPERT_CHECK_SET_FEEDBACK_DATE = 'expertCheck/SET_FEEDBACK_DATE'
export const EXPERT_CHECK_ANALYTICS_EVENT = 'expertCheck/ANALYTICS_EVENT'
export const FETCH_TICKET_DETAILS = 'document/FETCH_TICKET_DETAILS'
export const EXPERT_CHECK_SET_NETWORK_ERROR = 'expertCheck/SET_NETWORK_ERROR'
export const EXPERT_CHECK_SET_FEEDBACK_CONTENT = 'expertCheck/SET_FEEDBACK_CONTENT'
export const EXPERT_CHECK_CLEAR_FEEDBACK_CONTENT = 'expertCheck/CLEAR_FEEDBACK_CONTENT'
export const EXPERT_CHECK_SET_SHOULD_SUBMIT_ONLOAD =
  'expertCheck/SET_SHOULD_SUBMIT_ONLOAD'
export const EXPERT_CHECK_GET_FEEDBACK_COUNT = 'expertCheck/GET_FEEDBACK_COUNT'
export const EXPERT_CHECK_SET_SHOULD_SUBMIT_AFTER_LOGIN =
  'expertCheck/SET_SHOULD_SUBMIT_AFTER_LOGIN'

export const QUICK = 'quick' // maps to 24 hours in BFF
export const DETAILED = 'detailed' // maps to 48 hours in BFF

export type TurnAroundTime = typeof QUICK | typeof DETAILED

export interface CreateTicketPayload {
  description: string
  email: string
  feedbackTypes: FeedbackType[]
  turnAroundTime: TurnAroundTime
}

export interface SetFeedbackDatePayload {
  turnAroundDays: number
}

export interface CreateTicketSuccessPayload {
  ticketId: string
  feedbackTypes: FeedbackType[]
}

export type CreateTicketFailurePayload = Pick<CreateTicketSuccessPayload, 'feedbackTypes'>

export interface SetNetworkErrorPayload {
  networkError: boolean
}

export interface SetFeedbackContentPayload
  extends Omit<GetPaper_getPaper_feedbacks_feedbackContent, '__typename'> {}

export interface SetShouldSubmitOnloadPayload {
  shouldSubmit: boolean
}

export interface SetShouldSubmitAfterLoginPayload {
  shouldSubmitAfterLogin: boolean
}

export const createTicketSuccess = createStandardAction(EXPERT_CHECK_CREATE_SUCCESS)<
  CreateTicketSuccessPayload
>()
export const createTicket = createStandardAction(EXPERT_CHECK_CREATE_TICKET)<
  CreateTicketPayload
>()
export const createTicketFailure = createStandardAction(EXPERT_CHECK_CREATE_FAILURE)<
  CreateTicketFailurePayload
>()
export const setRedirectToSuccessFalse = createStandardAction(
  EXPERT_CHECK_SET_SUCCESS_REDIRECT_FALSE
)()
export const setFeedbackDate = createStandardAction(EXPERT_CHECK_SET_FEEDBACK_DATE)<
  SetFeedbackDatePayload
>()
export const setNetworkError = createStandardAction(EXPERT_CHECK_SET_NETWORK_ERROR)<
  SetNetworkErrorPayload
>()
export const setFeedbackContent = createStandardAction(EXPERT_CHECK_SET_FEEDBACK_CONTENT)<
  SetFeedbackContentPayload
>()
export const clearFeedbackContent = createStandardAction(
  EXPERT_CHECK_CLEAR_FEEDBACK_CONTENT
)()
export const setShouldSubmitOnload = createStandardAction(
  EXPERT_CHECK_SET_SHOULD_SUBMIT_ONLOAD
)<SetShouldSubmitOnloadPayload>()
export const getFeedbackCount = createStandardAction(EXPERT_CHECK_GET_FEEDBACK_COUNT)()
export const setShouldSubmitAfterLogin = createStandardAction(
  EXPERT_CHECK_SET_SHOULD_SUBMIT_AFTER_LOGIN
)<SetShouldSubmitAfterLoginPayload>()



// WEBPACK FOOTER //
// ./src/state/expertcheck/actions.ts